import { render } from "./ethoca-records.vue?vue&type=template&id=68f387e8&scoped=true"
import script from "./ethoca-records.vue?vue&type=script&lang=js"
export * from "./ethoca-records.vue?vue&type=script&lang=js"

import "./ethoca-records.vue?vue&type=style&index=0&id=68f387e8&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f387e8"]])

export default __exports__